module.exports = __webpack_public_path__ + "img/logo-w.4f9309ae.svg";